import React from "react"
import PrintIcon from "@mui/icons-material/Print"
import { IconButton } from "@mui/material"
import ModalPrintPackagingExecution from "./ModalPrintPackagingExecution"

// pses: prints the labels of several steps at once, in place of pse
const PrintPSE = ({ pse, pses, sx }) => {
  const [printPSE, setPrintPSE] = React.useState(false)

  const handleClose = () => {
    setPrintPSE(false)
  }

  const handleClick = (event) => {
    event.stopPropagation()
    setPrintPSE(true)
  }

  return (
    <>
      <IconButton onClick={handleClick} sx={sx}>
        <PrintIcon />
      </IconButton>
      {/* Mounted on opening only, so the labels are computed only for the step being printed */}
      {printPSE && <ModalPrintPackagingExecution open onClose={handleClose} pse={pse} pses={pses} />}
    </>
  )
}

export default PrintPSE